import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AuctionsStatusObject {
  id: number;
  titleEn: string;
  titleAr: string;
  descriptionEn: string;
  descriptionAr: string;
  customDescriptionEn: string;
  customDescriptionAr: string;
  isActive: boolean;
}

export interface AuctionsStatusListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  types: Array<AuctionsStatusObject>;
  errors: unknown;
}

@Module
export default class AuctionsStatusesModule
  extends VuexModule
  implements AuctionsStatusListInfo
{
  types = [] as Array<AuctionsStatusObject>;
  allTypes = [] as Array<AuctionsStatusObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get types list
   * @returns Array<AuctionsLocationsObject>
   */
  get auctionStatusesListing(): Array<AuctionsStatusObject> {
    return this.types;
  }

  /**
   * Get all types list
   * @returns Array<PropertyTypeObject>
   */
  get allAuctionsStatusesListing(): Array<AuctionsStatusObject> {
    return this.allTypes;
  }

  /**
   * Get total items
   * @returns number
   */
  get auctionStatusesListingCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_AUCTION_STATUSES](data) {
    this.types = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_AUCTION_STATUSES](data) {
    this.allTypes = data.data;
  }

  @Mutation
  [Mutations.RESET_AUCTION_STATUSES_LIST]() {
    this.types = [] as Array<AuctionsStatusObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  // @Mutation
  // [Mutations.SET_ALL_AUCTION_PROPERTY_TYPES](data) {
  //   this.allTypes = data.data;
  // }

  // @Mutation
  // [Mutations.SET_AUCTION_DESCRIPTIONS_CURRENT_PAGE](page) {
  //   this.currentPage = page;
  // }

  @Mutation
  [Mutations.SET_AUCTION_STATUSES_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_AUCTION_STATUSES_CURRENT_PAGE]() {
    this.types = [] as Array<AuctionsStatusObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_AUCTION_STATUS](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/auctions-status', data)
      .then(() => {
        this.context.commit(Mutations.SET_AUCTION_STATUSES_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_AUCTION_STATUS](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/auctions-status', id)
      .then(() => {
        this.context.commit(Mutations.SET_AUCTION_STATUSES_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_STATUS]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/auctions-status', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_AUCTION_STATUS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_STATUSES_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_AUCTION_STATUSES_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_AUCTION_STATUS](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-status', id);
  }

  @Action
  [Actions.GET_AUCTION_STATUSES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/auctions-status', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUCTION_STATUSES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  // @Action
  // [Actions.GET_ALL_AUCTION_STATUSES]() {
  //   ApiService.setAuthorizationHeader();
  //   return ApiService.get('/auctions-status/all')
  //     .then(({ data }) => {
  //       this.context.commit(Mutations.SET_ALL_AUCTION_STATUSES, data);
  //     })
  //     .catch(({ response }) => {
  //       console.error(response);
  //       // this.context.commit(Mutations.SET_ERROR, {
  //       //   [response.statusText]: [response.data.message],
  //       // });
  //     });
  // }
}
